function cleanCarouselImages() {
  const imgs = document.querySelectorAll('.omega-carousel-container img');

  imgs.forEach(img => {
    if (!img.src) return;

    const [base, query] = img.src.split('?');

    if (!query) return; 

    const params = new URLSearchParams(query);
    const version = params.get('v');

    let newUrl = base;
    if (version) {
      newUrl += `?v=${version}`;
    }

    if (img.src !== newUrl) {
      img.src = newUrl;
      console.log("Cleaned IMG:", newUrl);
    }
  });
}

cleanCarouselImages();

const container = document.querySelector('.omega-carousel-container');
if (container) {
  const observer = new MutationObserver(cleanCarouselImages);
  observer.observe(container, { childList: true, subtree: true });
}